import React from "react";
import { ReactComponent as HTML } from "../img/skill_icons/html.svg";

export const Html = () => {
  return <HTML title="html" />;
};
